import { render } from "./formTarefa.vue?vue&type=template&id=4592c262"
import script from "./formTarefa.vue?vue&type=script&lang=js"
export * from "./formTarefa.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./formTarefa.vue?vue&type=style&index=1&id=4592c262&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__